<div class="input-group input-group-sm">
    <spv2-efile-validation-status-dropdown [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" [isMultiSelect]="true" [multiSelectSettings]="{isGridFilter: true}"></spv2-efile-validation-status-dropdown>
</div>